var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classnames from 'classnames';
import omit from 'lodash/omit';
import React from 'react';
import EdsDropdown, { DropdownItem as EdsDropdownItem } from '@hedtech/react-design-system/core/es/Dropdown';
import Icon from '../Icon';
import Tokens from '../styles/Tokens';
import { createStyles, withStyles } from '../styles/withStyles';
const styles = createStyles({
    disabled: {},
    dropdownContainerLoader: {
        '& svg:not(.ds-spinner)': {
            display: 'none'
        },
        position: 'relative'
    },
    dropdownLoader: {
        position: 'absolute',
        right: Tokens.spacingSmall,
        top: '1.1875rem'
    },
    icon: {},
    select: {},
    selectMenu: {},
    smallDropdownLoader: {
        position: 'absolute',
        right: Tokens.spacingSmall,
        top: '0.5rem'
    }
});
const Dropdown = (props) => {
    const { classes, disabled, emptyOption, id, loading, native, options, size, value, onChange } = props, rest = __rest(props, ["classes", "disabled", "emptyOption", "id", "loading", "native", "options", "size", "value", "onChange"]);
    const onChangeCallback = (_event, child) => {
        if (onChange && child) {
            const valueChanged = child.props.value === ' ' ? '' : child.props.value;
            let option;
            if (options) {
                option = options.find(o => o.value === valueChanged);
            }
            if (!option) {
                option = {
                    description: child.props.label,
                    value: valueChanged
                };
            }
            onChange(option, id);
        }
    };
    const classOverrides = omit(classes, [
        'dropdownContainerLoader',
        'dropdownLoader',
        'smallDropdownLoader'
    ]);
    let classOuterDiv;
    let classLoaderDiv;
    if (size === 'small') {
        classLoaderDiv = classes.smallDropdownLoader;
    }
    else {
        classLoaderDiv = classes.dropdownLoader;
    }
    if (loading) {
        classOuterDiv = classnames(classOuterDiv, classes.dropdownContainerLoader);
    }
    return (React.createElement("div", { className: classOuterDiv },
        React.createElement(EdsDropdown, Object.assign({ classes: classOverrides, disabled: loading ? true : disabled, displayEmpty: true, id: id, native: native, size: size, value: value ? value : ' ', onChange: onChangeCallback }, rest),
            emptyOption ? (native ? (React.createElement("option", { value: emptyOption.value ? emptyOption.value : ' ' }, emptyOption.description)) : (React.createElement(EdsDropdownItem, { label: emptyOption.description, value: emptyOption.value ? emptyOption.value : ' ' }))) : undefined,
            options && options.map((option, i) => (native ? (React.createElement("option", { key: `${id}_${i}`, value: option.value ? option.value : ' ' }, option.description)) : (React.createElement(EdsDropdownItem, { key: `${id}_${i}`, label: option.description, value: option.value ? option.value : ' ' }))))),
        loading ? (React.createElement("span", { className: classLoaderDiv },
            React.createElement(Icon, { large: true, marginRight: true, name: "spinner", spin: true }))) : undefined));
};
Dropdown.defaultProps = {
    fullWidth: true,
    id: '',
    label: ''
};
const DropdownWithStyles = withStyles(styles)(Dropdown);
export default DropdownWithStyles;
